// 空间配置
export const bucket = process.env.VUE_APP_BUCKET

// 文件访问域名配置
export const picDns = bucket === 'jz-maintain-saas' ? 'https://qn.saas.gintell.cn/' : 'https://test.qn.saas.gintell.cn/'
export const videoDns = bucket === 'jz-maintain-saas' ? 'https://qn.saas.gintell.cn/' : 'https://test.qn.saas.gintell.cn/'
export const fileDns = bucket === 'jz-maintain-saas' ? 'https://qn.saas.gintell.cn/' : 'https://test.qn.saas.gintell.cn/'
